export default [
  {
    path: '/apps/cidade/list',
    name: 'apps-cidade-list',
    component: () => import('@/views/cadastros/gerais/cidade/list/Index.vue'),
    meta: {
      pageTitle: 'Cidade',
      resource: 'AdminHanes',
    },
  },
];
